import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import PropTypes from 'prop-types'
import styles from './registrationSchoolForm.scss'
import FloatLabelInput from '../components/floatLabelInput/floatLabelInputComponent'
import SmartDistrictSearch from '../containers/districtSearch/districtSearchContainer'
import SmartSchoolSearch from '../containers/schoolSearch/schoolSearchContainer'
import { actionCreators as schoolActions } from '../../redux/reducers/autoSuggest/autoSuggestReducer'
import { registerSchoolValidator } from 'tmw-validation'

function renderDistrictSearch (props) {
  return <SmartDistrictSearch name='district' {...props} />
}
function renderRegSchoolSearch (props) {
  return <SmartSchoolSearch name='school' {...props} />
}

export function RegistrationSchoolForm (props) {
  // const newProps = Object.assign(...props, {regFilter: true})
  const { t, handleSubmit } = props
  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <Field
        name='district'
        placeholder={t('form:schoolDistrictPlaceholder')}
        component={renderDistrictSearch}
        label={t('form:schoolDistrict')}
        setSchoolEmpty={() => props.change('school', '')}
        onSuggestionSelected={suggestion => {
          props.change('current_school_id', '')
        }}
      />

      <Field
        name='school'
        placeholder={t('form:currentSchoolPlaceholder')}
        component={renderRegSchoolSearch}
        label={t('form:currentSchool')}
        onSuggestionSelected={suggestion => {
          props.change('current_school_id', suggestion.id)
          props.setMou(suggestion.mou)
          if (!suggestion.mou) {
            props.change('lastName', '')
            props.change('birthDate', '')
          }
        }}
      />
      <Field
        name='email'
        component={FloatLabelInput}
        placeholder={t('form:emailPlacehodler')}
        type='email'
        label={t('form:email')}
      />

      <button type='submit' className={styles.bigButton2}>
        {t('form:next')}
      </button>

    </form>

  )
}

RegistrationSchoolForm.propTypes = {
  t: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setMou: PropTypes.func.isRequired,
  change: PropTypes.func
}

const boundActions = {
  setMou: schoolActions.setMou
}

function mapStateToProps (state, props) {
  return {}
}

export default compose(
  pure,
  translate(),
  connect(mapStateToProps, boundActions),
  reduxForm({
    form: 'registration',
    validate: registerSchoolValidator,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    isRegistrationForm: true,
    initialValues: {
      captchaResponse: null
    }
  })
)(RegistrationSchoolForm)



// WEBPACK FOOTER //
// ./src/forms/registrationSchool/registrationSchoolForm.js